import React, { ReactElement } from "react";
import ReturnSalesProductDetailsReportList from "../../components/Reports/ReturnSalesProductDetailsReport";
import MainLayout from "../../components/Layouts";

const ReturnSalesProductDetailsReportPage = (): ReactElement => {
  return (
    <MainLayout>
      <ReturnSalesProductDetailsReportList />
    </MainLayout>
  );
}; 

export default ReturnSalesProductDetailsReportPage;
